import { MenuService } from '@/layout/service/menu.service';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { Pesquisa } from '@/shared/components/pessoa/pesquisa/pesquisa';
import { PessoaService } from '@/shared/services/pessoa.service';
import { LoggerService } from '@/core/services/logger.service';
import { createOrgaoMenu, ORGAO_ROUTES } from './orgao.constants';

/**
 * Componente principal (layout) do módulo Órgão. Renderiza as rotas filhas,
 * publica o menu lateral e controla o diálogo de pesquisa de pessoas.
 */
@Component({
    selector: 'app-orgao-content',
    standalone: true,
    imports: [RouterModule, Pesquisa],
    template: `
        <main class="w-full">
            <div>
                <router-outlet></router-outlet>
            </div>
        </main>
        <app-pesquisa [showDialog]="pesquisarDialog()" (showDialogChange)="pesquisarDialog.set($event)" (pessoa)="carregarPessoa($event)"></app-pesquisa>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrgaoContent implements OnInit {
    private readonly menuService = inject(MenuService);
    private readonly router = inject(Router);
    private readonly pessoaService = inject(PessoaService);
    private readonly logger = inject(LoggerService);

    /** Visibilidade do diálogo de pesquisa. Signal → propaga sob OnPush mesmo acionado pelo menu global. */
    readonly pesquisarDialog = signal(false);

    /** Menu lateral do módulo (routerLink derivam de `ORGAO_ROUTES`). */
    readonly menu: MenuItem[] = createOrgaoMenu({
        pesquisarPessoa: () => this.pesquisarDialog.set(true)
    });

    ngOnInit(): void {
        this.menuService.setMenu(this.menu);
    }

    /** Persiste a pessoa selecionada e recarrega o dashboard do módulo. */
    carregarPessoa(pessoa?: Pessoa): void {
        if (!pessoa) {
            this.logger.error('Registro não encontrado ao selecionar pessoa.');
            return;
        }
        this.pessoaService.setPessoa(pessoa);
        this.recarregarRota(ORGAO_ROUTES.ROOT);
    }

    /** Força a reinicialização da rota informada (navega para '/' e volta), útil ao trocar a pessoa ativa. */
    private async recarregarRota(rota: string): Promise<void> {
        await this.router.navigateByUrl('/', { skipLocationChange: true });
        await this.router.navigate([rota]);
    }
}
